<template>
<div class="absolute" ref="divSize">
	<custom-popover ref="popover" :style="{left: left + 'px', top: (top + 8) + 'px' }" @close="$emit('close')" :backdrop="true">
		<div class="create-link-popover" :class="{ 'has-changes': hasChanges , 'move-left' : moveLeft}">   
            <!-- <span class="text-muted">{{linkURL}}</span> -->
            <div class="link-title">{{$t('link-creator.title')}}</div>
            <form class="d-flex" @submit="onSave">
                <input  ref="inputField" type="text" :placeholder="'URL'" v-model="linkObject.href">
                

                <label class="link-label">{{$t('link-creator.label')}}</label>
                 <div class="radio-btns">
                <label for="self_option" class="container">
                <input type="radio" id="self_option" value="_self" v-model="linkObject.target">
                <div class="check-indicator"></div>
                    <span>{{$t('link-creator.self')}}</span></label>

                    <label for="blank_option" class="container">
                <input type="radio" id="blank_option" value="_blank" v-model="linkObject.target">
                <div class="check-indicator"></div>
                    <span>{{$t('link-creator.blank')}}</span></label>
                </div>


            </form>    
            <div style="display: flex; flex-direction: column">
				<div class="save-footer" :class="{ 'can-save': hasChanges }">
					<div class="cancel" @click="onClose">{{$t('editor-expression.cancel')}} 
                        <i class="fa-light fa-times"></i>
                    </div>
					<div class="save" @click="onSave">{{$t('editor-expression.save')}} 
                        <i class="fa-light fa-check"></i>
                    </div>
				</div>
			</div>
		</div>
	</custom-popover>
</div>
</template>

<script>
import CustomPopover from "@/components/CustomPopover";
import EventBus from '@/assets/js/eventBus.js'
export default {
  name: "CreateLinkPopover",
  props: {
		linkInstance: { type: Object },
		top: Number,
		left: Number,
		moveLeft: Boolean,
		selectedText: String
  },
  data() {
    return {
			selectedVariable: null,
            hasChanges: false,
            formattedSynList: "",
            linkObject: {
                selectionText: this.selectedText,
                href: '',
                target: null
            }
		}
	},
	methods: {
        addLink(){},
		onSave () {
			// this.selectedVariable
			this.$emit('link-updated', this.linkObject)
		},
        onClose () {
            this.$emit('close')
        }
	},
	created(){
       
        EventBus.$emit('close_preview');
        
        if(this.linkInstance){
            this.linkObject = {...this.linkInstance}
        }
    },
    mounted(){
         this.$refs.inputField.focus()
    },
	destroyed(){
		EventBus.$emit('open_preview');
    },
    watch: {
        linkObject: {
				handler(val, oldVal) {
					this.hasChanges = true
				}, deep: true
			}
    },
	components: {
		CustomPopover
	},

}
</script>

<style lang="less">
.absolute{
		position: absolute;
		top: 10px;
}
	.custom-popover {
		position: fixed;
		z-index: 102;
		.create-link-popover {
			box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -2px 4px rgba(0, 0, 0, 0.25);
			position: fixed;
			width: 300px;
			top: 70px;		
			// left: calc(100% - 388px);	
            left: calc(100% - 388px + 68px);
			// color: #3d464a;
			background: #fff;
			min-width: 250px;
			overflow: auto;
			// max-height: 80%;
			max-height: calc(100% - 85px);
			border-radius: 2px;
            color: #3d464a;
            overflow: hidden;

            form{
                flex-direction: column;
                margin: 10px 20px 10px;
                justify-content: space-between;
                // border-bottom: 1px solid #3d464a1e;
                input{
                    width: 240px;
                    padding: 10px 0;
                    border: none;
                    border-bottom: 1px solid #3d464a1e;
                    &:focus{
                        outline:0;
                        &:focus-within{
                            border-bottom: 1px solid #3d464a;
                        }
                    +.new-synonym{
                        color: var(--orange-web); 
                        }
                    }
                }
                .link-label{
                    margin-top: 12px;
                    font-size: 14px;
            
                    font-weight: 400;
                    color: #8F979C;
                    letter-spacing: 0.6px;
                    line-height: 25px;
                    text-transform: uppercase;
                }  
        
            }
               

        }
    .radio-btns{
    // display: flex;
    display: grid;
    grid-template-columns: 1fr;

    color: #8f979c;
    padding-top: 12px;
    font-weight: 500;
    margin-bottom: 18px;
    span{
        margin-left: 24px;
        font-size: 12px;
        color: #383838;
    }
    }
    .container {
    display: block;
    position: relative;
    padding: 0;
    cursor: pointer;
    // font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked ~ .check-indicator {
    background-color: var(--orange-web);
    }

    &:checked ~ .check-indicator:after {
    display: block;
    }
    }


    &:hover input ~ .check-indicator {
    filter: brightness(1.05);
    }

    .check-indicator {
    position: absolute;
    top: 3px;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #e2e2e2;
    border-radius: 50%;


    &:after {
    content: "";
    position: absolute;
    display: none;
    }

    &:after {
    top: 6px;
    left: 6px;
    width: 6px;
    height: 6px;
        border-radius: 50%;
        background: white;
    }
    }  
    }

    .link-title {
			font-size: 14px;
			padding: 14px 20px ;
			font-weight: 400;
			color: #8F979C;
			letter-spacing: 0.6px;
			line-height: 25px;
            text-transform: uppercase;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
		}
	}

.create-link-popover.move-left{
		left: calc(100% - 590px);
	}
	
</style>


